import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { searchedGame, loading, loadGames } from "../actions/gamesAction";
// ? Components
import Game from "../components/Game";
import { CircularProgress } from "@material-ui/core";
import {
  Col,
  Row,
  ListGroup,
  Container,
  FormControl,
  InputGroup,
  Button,
} from "react-bootstrap";
import Jumbotron from "../components/Jumbotron";
import jumboImg from "../img/jumbo-img-1.jpg";
// ? Style
import styled from "styled-components";
import { motion } from "framer-motion";

function Home() {
  const props = {
    image: jumboImg,
    text: "",
  };

  // ? Redux
  const dispatch = useDispatch();
  const [textInput, setTextInput] = useState("");
  const inputHandler = (e) => {
    setTextInput(e.target.value);
  };

  const {
    searched = ["1"],
    upcoming,
    newGames,
    popular,
    isLoading,
  } = useSelector((state) => state.games);

  useEffect(() => {
    if (!popular || !newGames || !upcoming) {
      return dispatch(loading());
    }

    dispatch(loadGames(20));
  }, []);

  // ? Event Listner
  const submitSearch = (e) => {
    e.preventDefault();
    dispatch(searchedGame(textInput));
    setTextInput("");
  };
  const clearSearchHander = () => {
    dispatch({
      type: "CLEAR_SEARCH",
    });
  };

  return (
    <div>
      <div className="main_heading">
        <Jumbotron image={props.image} text={props.text} />
      </div>
      {/* Main */}
      <Container className="mt-4">
        <Row>
          {/* First column */}
          <Col md="4">
            <h4 className="mt-3">Search by</h4>
            <ListGroup>
              <ListGroup.Item className="list_group_links" variant="dark">
                <p>Upcoming Games</p>
              </ListGroup.Item>
              <ListGroup.Item className="list_group_links" variant="dark">
                <p>New Games</p>
              </ListGroup.Item>
              <ListGroup.Item className="list_group_links" variant="dark">
                <p>Popular Games</p>
              </ListGroup.Item>
            </ListGroup>
            <h4 className="mt-3">Seach Games</h4>
            <InputGroup className="my-3">
              <FormControl
                placeholder="eg: minecraft"
                value={textInput}
                onChange={inputHandler}
              />
              <InputGroup.Append>
                <Button
                  onClick={submitSearch}
                  variant="outline-dark"
                  className="text-light"
                >
                  Search
                </Button>
              </InputGroup.Append>
            </InputGroup>
          </Col>

          {/* Second column */}
          <Col md="8" sm="12">
            <Row>
              <Col md="12">
                {!!searched.length && (
                  <SearcheHeading onClick={clearSearchHander}>
                    Searched <span>(clear)</span>
                  </SearcheHeading>
                )}
                {!!upcoming.length && (
                  <SearcheHeading onClick={clearSearchHander}>
                    Games <span>(clear)</span>
                  </SearcheHeading>
                )}

                <Row>
                  {isLoading && (
                    <Col md="12" className="loader">
                      <CircularProgress
                        color="inherit"
                        size="8rem"
                      ></CircularProgress>
                    </Col>
                  )}

                  {searched.map((game) => (
                    <Col
                      key={game.id}
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="mb-3 mt-4"
                    >
                      <Game game={game} key={game.id} />
                    </Col>
                  ))}
                  {upcoming.map((game) => (
                    <Col
                      key={game.id}
                      lg="6"
                      md="6"
                      sm="12"
                      xs="12"
                      className="mb-3 mt-4"
                    >
                      <Game game={game} key={game.id} />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
// ? Style
const SearcheHeading = styled.h2`
  cursor: pointer;
  display: inline;
  margin-bottom: 1rem;
  span {
    font-size: 1.5rem;
    font-family: Montserrat;
  }
`;
export default Home;
